import { useState, useEffect, useContext, useMemo } from "react";
import { CardOne } from "../../components/cards/cardOne";
import { GoBackButton } from "../../components/buttons/goBack";
import { themeContext } from "../../context/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faTrophy,
  faGamepad,
  faClock,
  faFire,
} from "@fortawesome/free-solid-svg-icons";
import styles from "./OnlineArena.module.css";
import { useNetworkService } from "../../hooks/useNetworkService";

import { OnlineGameArena } from "./OnlineGameArena";
import { OnlineStartTimer } from "./OnlineStartTimer";

export const OnlineArena = ({ roomData, onBack, game }) => {
  const [gameStarted, setGameStarted] = useState(false);
  const [showStartTimer, setShowStartTimer] = useState(true);
  const [gameState, setGameState] = useState(null);
  const { theme } = useContext(themeContext);
  const { playerId, sendGameEvent } = useNetworkService();


  // Handle game start from timer
  const handleGameStart = () => {
    // Immediately transition to game - no intermediate screen
    setGameStarted(true);
    setShowStartTimer(false);
    game?.sounds?.gameStartSound?.play();
  };

  // Set up network event listeners
  useEffect(() => {
    const handleGameEvent = (eventData) => {
      // Handle incoming game events from other players
      // This will be expanded to sync game state
    };

    // Subscribe to game events
    const networkService = require("../../services/NetworkService").default;
    networkService.on("game_event", handleGameEvent);

    return () => {
      networkService.off("game_event", handleGameEvent);
    };
  }, []);

  // Initialize game state from room data
  useEffect(() => {
    if (roomData?.gameState) {
      setGameState(roomData.gameState);
    }
  }, [roomData]);

  // Priority 1: If game started, show game immediately
  if (gameStarted) {
    return (
      <OnlineGameArena
        roomData={{ ...roomData, gameState }}
        onBack={() => {
          // When returning from game, reset game state and go back to lobby
          setGameStarted(false);
          setShowStartTimer(true);
          setGameState(null);
          // Call the parent's onBack to go back to RoomLobby
          onBack();
        }}
        game={game}
      />
    );
  }

  // Priority 2: Show timer (default state, never show anything else)
  return (
    <OnlineStartTimer
      setShowGameStartTimer={setShowStartTimer}
      game={game}
      onGameStart={handleGameStart}
      setShowMenuOverlay={() => {}}
    />
  );
};
